import { createApp } from 'vue';

const languageSelector = createApp({
    data() {
        return {};
    },
    methods: {
        changeLanguage: function (langId, langUniqueSeoCode) {
            window.location.replace("/" + langUniqueSeoCode + "/changelanguage/" + langId + "?returnurl=" + encodeURIComponent(window.location.pathname + window.location.search));
        }
    }
});

languageSelector.mount('.language-selector-vue-bind');